import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsSettings = ({ t, }) => {
  return (
    <div className="main-area__header">
      <div className="row">
        <div className="details__menu">
          <ul>
            <NavLink to="/dashboard/settings/general">{t('general')}</NavLink>
            <NavLink to="/dashboard/settings/manage">{t('manage_account')}</NavLink>
          </ul>
        </div>
      </div>
    </div>
  );
};

BreadcrumbsSettings.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withScopedTranslations('breadcrumbs.settings')(BreadcrumbsSettings);
